<template>
    <div v-if="$store.getters.marchand && $store.getters.marchand._env==='live'" class="row" style="padding: 5px">
      <div class="col-12 mb-4 mt-5 pt-5">
        <v-card elevation="0">

           <h4 class="mt-3 mb-0 pb-0 text-center">
                    Gestion de l'ecole {{  school?._name }}
              </h4>
        <!-- Generation de lien de paiement pour multiple payment -->
         <div class="mt-5 pt-5">
             <v-row>

               <v-col lg="2" sm="3"></v-col>
               <v-col lg="4" sm="6">
                 <router-link :to="{name: 'intramScholar.settings', params: {school_id: this.$route.params.school_id}}" class="box-business">
                   <img src="/images/settings3.png" alt="intram-transaction">
                   <h4>{{ $t('menus.settings') }}</h4>
                 </router-link>
               </v-col>
              
              <v-col lg="4" sm="6">
                 <router-link :to="{name: 'intramScholar.academic.years', params: {school_id: this.$route.params.school_id}}"  class="box-business">
                   <img src="/images/academic-year.png" alt="intram-transaction">
                   <h4>{{ $t('menus.academicYears') }}</h4>
                 </router-link>
               </v-col>
              <v-col class="text-center" lg="12" sm="12">
                  <v-btn @click="$router.go(-1)" outlined style="border: none;background: #fff" title="Retourner">
                    <v-icon>mdi mdi-arrow-left</v-icon> Retour
                  </v-btn>

              </v-col>
             </v-row>
         </div>
         <v-col>
        
         </v-col>
        </v-card>
      </div>
    </div>
    <div v-else>
      <go-to-params></go-to-params>
    </div>
  </template>
  
  <script>
  import {client} from "../../store/services/client";

  /* eslint-disable */
  
  export default {
    label: "intramBusiness",
    data() {
      return {
        dialogDeleteCategory: false,
        products_tabs: [],
        school: null
      }
    },
    mounted() {
      this.initialize();
    },
    methods: {
      initialize() {
          this.getSchool()
      },
      async getSchool() {
        const response = await client({
          method: 'get',
          url: `/school-payments/schools/${this.$route.params.school_id}`
        })
            .then(resp => resp.data)
            .catch(() => {
              return {
                error: "true"
              }
            })
        if (!response.error)
          this.school = response;
      },
      checkisDashboard() {
        this.$emit('checkisDashboard', true);
      },
    },
    created() {
      this.checkisDashboard();
      this.initialize()
    }
  }
  </script>
  
  <style scoped>
  .box-business img{
    width: 200px;
    margin-bottom: 20px;
  }
  .box-business:hover{
    transition-duration: 500ms;
    transition-property: background-color;
    background-color: #ccc;
  }
  .box-business h4{
    text-decoration: none;
    
  }
  .box-business{
    display: block;
    background: #fff;
    text-align: center;
    padding: 30px;
    cursor: pointer;
    box-shadow: 0px 4px 12px rgb(39 48 57 / 5%);
    border-radius: 8px;
  }
  </style>
  